//NFC 태그 분류
export const infoNfcTagHeaderData = [
  { text: '구분', value: 'sort', widthClass: 'w20 mbFont' },
  { text: '타입1', value: 'type1', widthClass: 'w20 mbFont' },
  { text: '타입2', value: 'type2', widthClass: 'w20 mbFont' },
  { text: '타입3', value: 'type3', widthClass: 'w20 mbFont' },
  { text: '타입4', value: 'type4', widthClass: 'w20 mbFont' },
]

export const infoNfcTagBodytData = [
  {
    sort: { text: 'RF 인터페이스', className: 'tableHeader mbFont' },
    type1: { text: 'ISO 14443A', className: 'tableBody' },
    type2: { text: 'ISO 14443A', className: 'tableBody' },
    type3: { text: 'ISO 18092', className: 'tableBody' },
    type4: { text: 'ISO 14443', className: 'tableBody' },
  },
  {
    sort: { text: '속도', className: 'tableHeader mbFont' },
    type1: { text: '106 kbps', colSpan: 2, className: 'tableBody' },
    type2: { text: null },
    type3: { text: '212 kbps', className: 'tableBody' },
    type4: { text: '106-424 kbps', className: 'tableBody' },
  },
  {
    sort: { text: '프로토콜', className: 'tableHeader mbFont' },
    type1: { text: '자체명령어', colSpan: 2, className: 'tableBody' },
    type2: { text: null },
    type3: { text: 'Felica 프로토콜', className: 'tableBody' },
    type4: { text: (<>ISO 14443-4<br />ISO 7816-4</>), className: 'tableBody' },
  },
  {
    sort: { text: '메모리 크기', className: 'tableHeader mbFont' },
    type1: { text: '1KB 이하', className: 'tableBody' },
    type2: { text: '2KB 이하', className: 'tableBody' },
    type3: { text: '1KB 이하', className: 'tableBody' },
    type4: { text: '64KB 이하', className: 'tableBody' },
  },
  {
    sort: { text: '응용분야', className: 'tableHeader mbFont' },
    type1: { text: '단일 응용서비스용 저용량 태그', colSpan: 2, className: 'tableBody' },
    type2: { text: null },
    type3: { text: '다중 응용서비스용 고용량 태그', colSpan: 2, className: 'tableBody' },
    type4: { text: null },
  },
]


//태그의 종류별 특징
export const infoTagHeaderData = [
  { text: '방식', value: 'way', colSpan: 2, widthClass: 'rfidInfoWayHeader mbFont' },
  { text: null, value: 'wayVal' },
  { text: '원리', value: 'prcp', widthClass: 'mbFont' },
]

export const infoTagBodyData = [
  {
    way: { text: '읽기 / 쓰기 가능여부', rowSpan: 2, className: 'tableHeader mbFont' },
    wayVal: { text: 'READING', className: 'tableBody' },
    prcp: { text: (<>
      제조시 정보입력, 입력된 정보는 변경 불가<br />
      가격이 저렴하여 바코드와 같이 단순인식 분야에서 활용
    </>), className: 'tableBody' },
  },
  {
    way: { text: null },
    wayVal: { text: 'WRITING', className: 'tableBody' },
    prcp: { text: '사용자가 데이터를 1회 입력할 수 있으며, 입력 후에는 변경 불가', className: 'tableBody' },
  },
  {
    way: { text: '태그 전원 유무', rowSpan: 5, className: 'tableHeader mbFont' },
    wayVal: { text: 'RE-WRITING', className: 'tableBody' },
    prcp: { text: '여러번 데이터를 입력하고 변경이 가능', className: 'tableBody' },
  },
  {
    way: { text: null },
    wayVal: { text: '능동형(Active)', rowSpan:2, className: 'tableBody' },
    prcp: { text: '태그에 배터리가 부착되어 수십미터 원거리 통신용', className: 'tableBody' },
  },
  {
    way: { text: null },
    wayVal: { text: null },
    prcp: { text: '가격이 높고, 수명 제한 -UHF대역 이상에서 사용', className: 'tableBody' },
  },
  {
    way: { text: null },
    wayVal: { text: '수동형(Passive)', rowSpan:2, className: 'tableBody' },
    prcp: { text: '태그에 배터리가 없고, 10미터 이내의 근거리 통신용', className: 'tableBody' },
  },
  {
    way: { text: null },
    wayVal: { text: null },
    prcp: { text: '가격이 저렴하고, 수명이 반영구적임', className: 'tableBody' },
  },
]


//유사 매체별 특징
export const infoMediumHeaderData = [
  { text: '구분', value: 'sort', widthClass: 'w25 mbFont' },
  { text: 'RFID', value: 'rfid', widthClass: 'w25 mbFont' },
  { text: '스마트카드', value: 'smart', widthClass: 'w25 mbFont' },
  { text: '바코드', value: 'bar', widthClass: 'w25 mbFont' },
]

export const infoMediumBodyData = [
  {
    sort: { text: '주파수/통신방식', className: 'tableHeader mbFont' }, 
    rfid: { text: (<>125Khz<br />13.56Mhz~2.45Ghz</>), className: 'tableBody' }, 
    smart: { text: '13.56Mhz', className: 'tableBody' }, 
    bar: { text: '적외선', className: 'tableBody' },
  },
  {
    sort: { text: '인식거리', className: 'tableHeader mbFont' }, 
    rfid: { text: (<>0~100m(능동형)<br />0~10m(수동형)</>), className: 'tableBody' }, 
    smart: { text: '50cm', className: 'tableBody' }, 
    bar: { text: '0~50cm', className: 'tableBody' },
  },
  {
    sort: { text: '인식속도', className: 'tableHeader mbFont' }, 
    rfid: { text: '0.01~0.1초', className: 'tableBody' }, 
    smart: { text: '1초 이내', className: 'tableBody' }, 
    bar: { text: '4초이내', className: 'tableBody' },
  },
  {
    sort: { text: '적용영역', className: 'tableHeader mbFont' }, 
    rfid: { text: '모든 객체', className: 'tableBody' }, 
    smart: { text: '사물', className: 'tableBody' }, 
    bar: { text: '사물', className: 'tableBody' },
  },
  {
    sort: { text: '형태', className: 'tableHeader mbFont' }, 
    rfid: { text: '라벨, 카드, 스틱 등', className: 'tableBody' }, 
    smart: { text: '카드', className: 'tableBody' }, 
    bar: { text: '특수프린트', className: 'tableBody' },
  },
  {
    sort: { text: '투과여부', className: 'tableHeader mbFont' }, 
    rfid: { text: '가능', className: 'tableBody' }, 
    smart: { text: '불가능', className: 'tableBody' }, 
    bar: { text: '불가능', className: 'tableBody' },
  },
  {
    sort: { text: '데이터기록', className: 'tableHeader mbFont' }, 
    rfid: { text: '가능', className: 'tableBody' }, 
    smart: { text: '가능', className: 'tableBody' }, 
    bar: { text: '불가능', className: 'tableBody' },
  },
]


//주파수 종류별 특징
export const infoFreqHeaderData = [
  { text: '구분', value: 'sort', widthClass: 'w25 mbFont' },
  { text: '특징', value: 'char', widthClass: 'mbFont' },
  { text: '적용분야', value: 'area', widthClass: 'mbFont' },
]

export const infoFreqBodyData = [
  {
    sort: { text: (<>저주파수 대역<br />125Khz, 134Khz</>), className: 'tableHeader mbFont' }, 
    char: { text: (<>저가형<br />느린 인식속도</>), className: 'tableBody' }, 
    area: { text: (<>출입통제<br />재고관리</>), className: 'tableBody' }, 
  },
  {
    sort: { text: (<>중간주파수 대역<br />13.56Mhz</>), className: 'tableHeader mbFont' }, 
    char: { text: (<>중저가형<br />비금속 장애물 투과성 우수</>), className: 'tableBody' }, 
    area: { text: (<>출입통제<br />스마트카드<br />교통카드</>), className: 'tableBody' }, 
  },
  {
    sort: { text: (<>고주파수 대역<br />433Mhz</>), className: 'tableHeader mbFont' }, 
    char: { text: (<>고가형<br />능동형<br />긴 인식거리</>), className: 'tableBody' }, 
    area: { text: '컨테이너 식별 및 추적', className: 'tableBody' }, 
  },
  {
    sort: { text: (<>고주파수 대역<br />860~960Mhz</>), className: 'tableHeader mbFont' }, 
    char: { text: (<>저가형<br />장거리 인식(~10m)<br />금속및 액체 인식률 저조</>), className: 'tableBody' }, 
    area: { text: '유통물류분야', className: 'tableBody' }, 
  },
  {
    sort: { text: (<>마이크로파대역<br />2.45Ghz</>), className: 'tableHeader mbFont' }, 
    char: { text: (<>장거리(~27m)<br />빠른 인식속도</>), className: 'tableBody' }, 
    area: { text: '톨게이트 시스템', className: 'tableBody' }, 
  },
]


/* ============================================= CHIP AREA ============================================= */

//LF(125Khz)
export const chipLfHeaderData = [
  { text: '제조사', value: 'maker', widthClass: 'mbFont' },
  { text: '모델명', value: 'name', widthClass: 'mbFont' },
  { text: '국제표준규격', value: 'standard', widthClass: 'mbFont' },
  { text: '메모리 용량', value: 'memory', widthClass: 'mbFont' },
  { text: 'UID', value: 'uid', widthClass: 'mbFont' },
  { text: 'R/W', value: 'rw', widthClass: 'mbFont' },
  { text: '통신속도', value: 'speed', widthClass: 'mbFont' },
]

export const chipLfBodyata = [
  {
    maker : { text: 'EM MicroElectronics', rowSpan:2, className: 'tableHeader mbFont' }, 
    name: { text: 'EM4200', className: 'tableBody' },
    standard: { text: 'ISO11784/11785', className: 'tableBody' }, 
    memory: { text: '128 bit', className: 'tableBody' }, 
    uid: { text: '-', className: 'tableBody' }, 
    rw: { text: 'Read Only', className: 'tableBody' },
    speed: { text: '2 or 4Kbits/s', className: 'tableBody' },
  },
  {
    maker : { text: null }, 
    name: { text: 'EM4305', className: 'tableBody' },
    standard: { text: 'ISO11784/11785', className: 'tableBody' }, 
    memory: { text: '512 bit', className: 'tableBody' }, 
    uid: { text: '-', className: 'tableBody' }, 
    rw: { text: 'Read Only', className: 'tableBody' },
    speed: { text: '2 or 4Kbits/s', className: 'tableBody' },
  },
  {
    maker : { text: 'ATMEL', className: 'tableHeader mbFont' }, 
    name: { text: 'ATA5577', className: 'tableBody' },
    standard: { text: 'ISO11784/11785', className: 'tableBody' }, 
    memory: { text: (<>363 bit<br />(11block + 1lock bit)</>), className: 'tableBody' }, 
    uid: { text: '-', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' },
    speed: { text: '2~128Kbits/s', className: 'tableBody' },
  },
]


//HF(13.56Mhz)
export const chipHfHeaderData = [
  { text: '제조사', value: 'maker', widthClass: 'w10 mbFont' },
  { text: '모델명', value: 'name', widthClass: 'mbFont' },
  { text: '국제표준규격', value: 'standard', widthClass: 'mbFont' },
  { text: '메모리 용량', value: 'memory', widthClass: 'mbFont' },
  { text: 'UID', value: 'uid', widthClass: 'mbFont' },
  { text: 'R/W', value: 'rw', widthClass: 'mbFont' },
  { text: '통신속도', value: 'speed', widthClass: 'mbFont' },
  { text: '호환', value: 'comp', widthClass: 'mbFont' },
]

export const chipHfBodyData = [
  {
    maker : { text: 'Mifare 시리즈', colSpan: 8, className: 'tableHeader mbFont' }, 
    name: { text: null },
    standard: { text: null }, 
    memory: { text: null }, 
    uid: { text: null }, 
    rw: { text: null },
    speed: { text: null },
    comp: { text: null },
  },
  {
    maker : { text: 'NXP', rowSpan:25, className: 'tableHeader mbFont' }, 
    name: { text: 'Mifare Classic', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '1K / 4K', className: 'tableBody' }, 
    uid: { text: '4byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: (<>layer 3<br />까지 호환</>), rowSpan: 5 , className: 'tableBody' },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare Ultralight', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '64 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare Ultralight C', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '192 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare Ultralight EV1', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '80 byte / 164 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare Ultralight NANO', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '40 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '848kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare DESFire EV1', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '2K / 4K / 8K', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '848kbit/s', className: 'tableBody' }, 
    comp: { text: (<>layer 4<br />까지 호환</>), rowSpan: 6 , className: 'tableBody' },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare DESFire EV2', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '2K / 4K / 8K', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '848kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare Plus EV1', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '2K / 4K', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '848kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare Plus S', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '2K / 4K', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '848kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare Plus X', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '2K / 4K', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '848kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'Mifare Plus SE', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '1K', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '848kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'NTAG 시리즈', colSpan: 7 ,className: 'tableHeader mbFont' },
    standard: { text: null }, 
    memory: { text: null }, 
    uid: { text: null }, 
    rw: { text: null },
    speed: { text: null },
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'NTAG210', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '80 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: (<>layer 3<br />까지 호환</>), rowSpan: 6 , className: 'tableBody' },
  },
  {
    maker : { text: null }, 
    name: { text: 'NTAG213', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '180 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'NTAG215', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '540 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'NTAG216', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '924 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'NTAG223DNA', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '114 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'NTAG224DNA', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '208 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '106kbit/s', className: 'tableBody' }, 
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'NTAG424 DNA', className: 'tableBody' }, 
    standard: { text: 'ISO 14443A', className: 'tableBody' }, 
    memory: { text: '416 byte', className: 'tableBody' }, 
    uid: { text: '7byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '848kbit/s', className: 'tableBody' }, 
    comp: { text: (<>layer 4<br />까지 호환</>), rowSpan: 1 , className: 'tableBody' },
  },
  {
    maker : { text: 'I-CODE 시리즈', colSpan: 7, className: 'tableHeader mbFont' }, 
    name: { text: null },
    standard: { text: null }, 
    memory: { text: null }, 
    uid: { text: null }, 
    rw: { text: null },
    speed: { text: null },
    comp: { text: null },
  },
  {
    maker : { text: null }, 
    name: { text: 'I-CODE SLI', className: 'tableBody' }, 
    standard: { text: (<>ISO 15693<br />ISO 18000-3</>), className: 'tableBody' }, 
    memory: { text: '1,024bit', className: 'tableBody' }, 
    uid: { text: '8byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '최대 53kbit/s', className: 'tableBody' }, 
    comp: { text: '' },
  },
  {
    maker : { text: null }, 
    name: { text: 'I-CODE SLIX', className: 'tableBody' }, 
    standard: { text: (<>ISO 15693<br />ISO 18000-3</>), className: 'tableBody' }, 
    memory: { text: '1,024bit', className: 'tableBody' }, 
    uid: { text: '8byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '최대 53kbit/s', className: 'tableBody' }, 
    comp: { text: '' },
  },
  {
    maker : { text: null }, 
    name: { text: 'I-CODE SLIX2', className: 'tableBody' }, 
    standard: { text: (<>ISO 15693<br />ISO 18000-3</>), className: 'tableBody' }, 
    memory: { text: '2,528bit', className: 'tableBody' }, 
    uid: { text: '8byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '최대 53kbit/s', className: 'tableBody' }, 
    comp: { text: '' },

  },
  {
    maker : { text: null }, 
    name: { text: 'I-CODE SLIX-L', className: 'tableBody' }, 
    standard: { text: (<>ISO 15693<br />ISO 18000-3</>), className: 'tableBody' }, 
    memory: { text: '512bit', className: 'tableBody' }, 
    uid: { text: '8byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '최대 53kbit/s', className: 'tableBody' }, 
    comp: { text: '' },
  },
  {
    maker : { text: null }, 
    name: { text: 'I-CODE SLIX-S', className: 'tableBody' }, 
    standard: { text: (<>ISO 15693<br />ISO 18000-3</>), className: 'tableBody' }, 
    memory: { text: '2,048bit', className: 'tableBody' }, 
    uid: { text: '8byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '최대 53kbit/s', className: 'tableBody' }, 
    comp: { text: '' },
  },
  {
    maker : { text: 'SONY(Felica)', className: 'tableHeader mbFont' }, 
    name: { text: (<>RC-S965<br />(Felica Lite)</>), className: 'tableBody' }, 
    standard: { text: 'ISO 18092', className: 'tableBody' }, 
    memory: { text: '224 byte', className: 'tableBody' }, 
    uid: { text: '8byte', className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '212kbps', className: 'tableBody' }, 
    comp: { text: '' },
  },
]


//UHF(900Mhz)

export const chipUhfHeaderData = [
  { text: '제조사', value: 'maker', widthClass: ' mbFont' },
  { text: '모델명', value: 'name', widthClass: ' mbFont' },
  { text: '국제표준규격', value: 'standard', widthClass: ' mbFont' },
  { text: '메모리 용량', value: 'memory', widthClass: ' mbFont' },
  { text: '메모리 영역', value: 'memoryArea', widthClass: ' mbFont' },
  { text: 'R/W', value: 'rw', widthClass: ' mbFont' },
  { text: '통신속도', value: 'speed', widthClass: ' mbFont' },
]

export const chipUhfBodyData = [
  {
    maker : { text: 'Impinj', rowSpan:5, className: 'tableHeader mbFont' }, 
    name: { text: 'Monza 4E', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '736 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 496 bit<br />TID : 48 bit<br />USER : 128 bit<br />Reserved : 64 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '256kbps', className: 'tableBody' }, 
  },
  {
    maker : { text: null }, name: { text: 'Monza 4QT', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '752 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 128 bit<br />TID : 48 bit<br />USER : 512 bit<br />Reserved : 64 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '256kbps', className: 'tableBody' }, 
  },
  {
    maker : { text: null }, name: { text: 'Monza R6', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '144 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 96 bit<br />TID : 48 bit<br />(32bit S/N포함)<br />User : -<br />Reserved : -</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '170kbps', className: 'tableBody' }, 
  },
  {
    maker : { text: null }, name: { text: 'Monza R6-P', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '320 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 128 bit<br />TID : 96 bit<br />(48bit S/N포함)<br />User : 32bit<br />Reserved : 64 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '16bits/ms', className: 'tableBody' }, 
  },
  {
    maker : { text: null }, name: { text: 'Monza S6-C', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '320 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 128 bit<br />TID : 96 bit<br />(48bit S/N포함)<br />User : 32bit<br />Reserved : 64 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '16bits/ms', className: 'tableBody' }, 
  },
  {
    maker : { text: 'Alien Technology', rowSpan:3, className: 'tableHeader mbFont' }, 
    name: { text: 'Higgs 3', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '800 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 96 bit<br />(~480bit)<br />TID : 64 bit<br />USER : 512 bit<br />Reserved : 128 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '-', className: 'tableBody' }, 
  },
  {
    maker : { text: null }, 
    name: { text: 'Higgs 4', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '512 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 128 bit<br />TID : 64 bit<br />USER : 128 bit<br />Reserved : 64 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '-', className: 'tableBody' }, 
  },
  {
    maker : { text: null }, 
    name: { text: 'Higgs 9', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '1,264 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 96~496 bit<br />TID : 48 bit<br />USER : 688 bit<br />Reserved : 32 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '-', className: 'tableBody' }, 
  },
  {
    maker : { text: 'NXP', rowSpan:5, className: 'tableHeader mbFont' }, 
    name: { text: 'UCODE G2iL', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '256 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 128 bit<br />TID : 64 bit<br />(32bit S/N포함)<br />User : -<br />Reserved : 64 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '최대640Kbits/s', className: 'tableBody' }, 
  },
  {
    maker : { text: null }, 
    name: { text: 'UCODE G2iM', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '1040 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 256 bit<br />TID : 96 bit<br />(48bit S/N포함)<br />User TID : 112 bit<br />User : 512 bit<br />Reserved : 64 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '최대640Kbits/s', className: 'tableBody' }, 
  },
  {
    maker : { text: null }, 
    name: { text: 'UCODE 7', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '288 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 128 bit<br />TID : 96 bit<br />(48bit S/N포함)<br />User : -<br />Reserved : 64 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '16bits/ms', className: 'tableBody' }, 
  },
  {
    maker : { text: null }, 
    name: { text: 'UCODE 8', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '288 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 128 bit<br />TID : 96 bit<br />(48bit S/N포함)<br />User : -<br />Reserved : 64 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '16bits/ms', className: 'tableBody' }, 
  },
  { 
    maker : { text: null }, 
    name: { text: 'UCODE 9', className: 'tableBody' }, 
    standard: { text: 'ISO18000-6C', className: 'tableBody' }, 
    memory: { text: '224 bit', className: 'tableBody' }, 
    memoryArea: { text: (<>EPC : 96 bit<br />TID : 96 bit<br />(48bit S/N포함)<br />User : -<br />Reserved : 32 bit</>), className: 'tableBody' }, 
    rw: { text: 'R/W', className: 'tableBody' }, 
    speed: { text: '16bits/ms', className: 'tableBody' }, 
  },
]





































































































